












import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import CategoryExpansionPanel from '@/components/organisms/CategoryExpansionPanel.vue';
import {GCICategoryInfoRes, GCIContentsListRes, GCICategoryListRes, GCIContentsInfoRes} from '@/model/dto/res/contents/get-category-list-res';
import _ from 'lodash';

@Component({
  components: {
    'category-expansion-panel': CategoryExpansionPanel
  }
})
export default class CategoryViewer extends Vue {
  /** Data **/
  /** Computed **/
  /** Refs **/
  /** Methods **/
  /** Watch **/
  @Watch('currentAcount')
  private doCurrentAcount() {
    const token = this.$route.query.token ?? userModule.apiToken;
    contentsService.setBreadcrumb(this.$route.path, 'category', null, null, null, null, `${token}`);
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {
    appModule.startLoading();
    const token = this.$route.query.token ?? userModule.apiToken;
    let categoryId = 0;
    await appModule.requestCategorySelectInfo(this.$route.params.category).catch(err => {
      this.errorPropagation(err);
    });
    if (appModule.categorySelectInfo.length > 0) {
      categoryId = appModule.categorySelectInfo[0].category_id;
    }

    await appModule.requestCategoryInfo({
      c: categoryId,
      q: appModule.searchKeyword !== '' ? appModule.searchKeyword : '',
      s: 0,
      o: 'dp',
      categoryType: this.$route.params.category
    }).catch(err => {
      this.errorPropagation(err);
    });
    contentsService.setBreadcrumb(this.$route.path, 'category', null, null, null, null, `${token}`); // 現在のパンくず情報をセット
    const func = _.debounce(() => {
      appModule.stopLoading();
    }, 1000);
    func();
  }

}
